<ids-shimmer
  *ngIf="!table"
  [width]="width"
  [height]="height || null"
  [class]="style"
></ids-shimmer>

<div
  *ngIf="table"
	class="table-shimmer-container"
>
  <ids-shimmer
    *ngFor="let line of lines"
    [width]="width"
    [height]="height || null"
    [style]="style"
  ></ids-shimmer>
</div>
